import React, {useEffect, useState} from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import TextField from '@material-ui/core/TextField';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';

export default function ModalExtraordinarioFecha(props) {
    const [fecha, setFecha] = useState("");

    useEffect(() => {
        if (props.open) {
            setFecha(props.initialFecha || "");
        }
    }, [props.open, props.initialFecha]);

    return (
        <Dialog
            open={props.open}
            onClose={props.onSkip}
            fullWidth={true}
            maxWidth="xs"
            aria-labelledby="form-dialog-title"
        >
            <DialogTitle id="form-dialog-title">Fecha del extraordinario</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Captura la fecha en que se presentó el examen extraordinario.
                    Aparecerá en el kardex como EXT dd/mm/aa.
                </DialogContentText>
                <TextField
                    autoFocus
                    fullWidth
                    type="date"
                    label="Fecha del examen"
                    value={fecha}
                    onChange={event => setFecha(event.target.value)}
                    InputLabelProps={{shrink: true}}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onSkip} color="primary">
                    Guardar sin fecha
                </Button>
                <Button onClick={() => props.onConfirm(fecha)} color="primary" disabled={!fecha}>
                    Guardar
                </Button>
            </DialogActions>
        </Dialog>
    );
};
